export default "__VITE_ASSET__DJYqn_HT__"